import React, { ReactNode } from 'react';

import { RunningExperiments, useExperiments } from 'state/experiments';

export function EnableChallenge__Experiment({ children }: { children: ReactNode }) {
  const { variant } = useExperiments();
  const isTreatment = variant(RunningExperiments.EnableChallenge, 'treatment');

  if (isTreatment) {
    return <>{children}</>;
  }
  return null;
}
